export class PomieszczenieDoArkusza {
    id: string;
    nazwa: string;
    pietro: string;
    czyWybrano: boolean;
}